module.exports = __webpack_public_path__ + "static/media/Charizard.6f51f9f6.webp";